var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVe(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cf142b",
    d: "M.7 0H54v40H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00247d",
    d: "M.7 0H54v26.7H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M.7 0H54v13.3H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.7 14.5 29 16l.9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m29.7 14.5.2 1.7-1 .1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m31 16-1.6-.3-.2 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m31 16-1.4.7-.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m28 15.4 1.1 1.2.7-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m28 15.4 1.6.3-.2 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.1 17.7 30 16l-1 .2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.1 17.7 29 16.5l.7-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m28.2 17.3 1.5-.7-.4-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.2 17.3 29 16l.9.4zm6-1.1-1.3 1.1.7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m34.2 16.2-.4 1.6-1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m35 18-1.5-.9-.5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m35 18-1.7.1-.1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m32.2 16.4.7 1.5 1-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m32.2 16.4 1.5.8-.5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m33.5 19.3.3-1.7-1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m33.5 19.3-.7-1.6 1-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m31.8 18.3 1.7-.2-.1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m31.8 18.3 1.3-1.1.6.7zm6 .9-1.5.7.3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m37.8 19.2-.9 1.4-.8-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m38 21.2-1.2-1.3-.7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m38 21.2-1.7-.5.3-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m35.9 18.7.1 1.7h1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m35.9 18.7 1 1.3-.7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m36.1 21.9.9-1.4-.8-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.1 21.9v-1.7h.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m34.9 20.4 1.6.4.2-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m34.9 20.4 1.5-.6.4.9zm5.3 2.9-1.7.1v1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m40.2 23.3-1.4 1-.6-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m39.6 25.2-.6-1.6-.9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m39.6 25.2-1.3-1 .5-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m38.6 22.2-.5 1.6 1 .3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m38.6 22.2.5 1.6-1 .3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m37.7 25.3 1.3-1-.6-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m37.7 25.3.5-1.6.9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m37 23.4 1.4 1 .6-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37 23.4h1.7v1zm-22.5-.1 1.3 1 .6-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m14.5 23.3 1.7.1v1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m16.1 22.2-.5 1.6.9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m16.1 22.2.5 1.6-1 .3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m15 25.2 1.4-1-.5-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m15 25.2.6-1.6 1 .4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.7 23.4H16v1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.7 23.4-1.4 1-.6-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17 25.3-.5-1.6-1 .2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17 25.3-1.3-1 .6-.8zm-.1-6.1.9 1.4.8-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m16.9 19.2 1.5.7-.4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.8 18.7 17.7 20l.8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m18.8 18.7-.2 1.7h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m16.7 21.2 1.6-.5-.2-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m16.7 21.2 1.1-1.3.8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m19.8 20.4-1.6-.6-.3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m19.8 20.4-1.6.4-.3-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m18.5 21.9.1-1.7h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m18.5 21.9-.8-1.4.8-.5zm2-5.7.4 1.6 1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m20.5 16.2 1.2 1.1-.6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.4 16.4-1.4.8.5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.4 16.4-.7 1.5-.8-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m19.7 18 1.7.1v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m19.7 18 1.5-.9.5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.9 18.3-1.3-1.1-.7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.9 18.3-1.7-.2.1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m21.2 19.3.6-1.6-.9-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m21.2 19.3-.4-1.7 1-.2zm3.8-4.8-.3 1.7 1 .1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m25 14.5.7 1.5-.8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.7 15.4-1.6.3.1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.7 15.4-1.2 1.2-.7-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m23.6 16 1.5.7.4-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m23.6 16 1.7-.3.1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.4 17.3-.8-1.4-.8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.4 17.3-1.4-.7.4-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m24.5 17.7 1.2-1.2-.7-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m24.5 17.7.3-1.7 1 .2z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVe);
export default __webpack_public_path__ + "static/media/ve.13dd143ab85c4876cf2aedac600b8c36.svg";
export { ForwardRef as ReactComponent };